import React, { Component } from "react";
import { Button } from "antd";
import { config } from "../../utils/word_detective_config";


// Error Boundary for  error handling

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('HexiLexi Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center', 
          background: '#fff8e7', 
          borderRadius: '20px',
          margin: '20px',
          border: '2px dashed #ffc107'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🧙‍♀️💫</div>
          <h2 style={{ color: config.ui.colors.primary }}>Oops! Ein magischer Fehler ist passiert!</h2>
          <p style={{ color: '#666' }}>{config.ai.personality.name} muss kurz nachdenken...</p>
          <Button 
            type="primary" 
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{ marginTop: '20px', background: config.ui.colors.primary, borderColor: config.ui.colors.primary }}
          >
            Nochmal versuchen ✨
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;